import { render, staticRenderFns } from "./product-name-trigger.vue?vue&type=template&id=76261c42&lang=pug&"
import script from "./product-name-trigger.vue?vue&type=script&lang=js&"
export * from "./product-name-trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports